export const NEW_MEXICO = "New Mexico";
export const COLORADO = "Colorado";
export const MINNESOTA = "Minnesota";
export const WISCONSIN = "Wisconsin";
